export function postSecureCardViewerMessage(payload) {
    const bridge = globalThis.ReactNativeWebView;
    if (!bridge?.postMessage) {
        return;
    }
    bridge.postMessage(JSON.stringify(payload));
}
export function postSecureCardViewerContentHeight(contentElement) {
    if (!contentElement) {
        return;
    }
    const height = Math.ceil(Math.max(contentElement.getBoundingClientRect().height, contentElement.scrollHeight));
    if (!Number.isFinite(height) || height <= 0) {
        return;
    }
    postSecureCardViewerMessage({ message: 'contentHeight', height });
}
